import { Col } from "react-bootstrap";

const TextView = ({
  image,
  title,
  text,
  handleClick,
  children,
  loading,
  btnText,
}) => {
  return (
    <Col sm={12} className="modal-header px-2">
      <img src={image} alt="opened-letter-icon" />
      <h3 className="mt-4 mb-3">{title}</h3>
      <p>{text}</p>
      {children}
      <div className="form-group pt-2 pb-2">
        <button
          onClick={handleClick}
          className="btn btn-primary btn-block btn-full"
          disabled={loading}
        >
          {btnText}
        </button>
      </div>
    </Col>
  );
};
export default TextView;
